var $$ = require('domtastic');
//require('./module/viewport');
var Hooks = require('./module/hooks');
// var spop = require('./module/spop');
var doc = $$(document);

require('./module/ajaxloader')();

doc.on('complete', init);

doc.ready(init);

function init(e) {
	
	require('./module/auch');
	
//	var smoothscroll = require('./module/smoothscroll');
	
//	console.log(smoothscroll);
	
	require('./module/responsive');
	// require('./components/table-responsive');
	
	// require('./components/wpas');
	// require('./components/profile');
//	 require('./module/fitvids');
//   // require('./components/rating');
//   // require('./components/add-listing-form');
	
	Hooks.doAction('_init');
}


//////////////////
// WEBPACK FOOTER
// ./assets/js/index.js
// module id = 62
// module chunks = 0